import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/page-header-bg.jpg';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo1.svg';
import Footer from '../../components/Layout/Footer';
import VisualizerMain from './VisualizerMain';

const Visualizer = () => {
    const [isVisible, setIsVisible] = useState(false);
    
    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <React.Fragment>
            <Header
                navImg={navImg1}
                parentMenu='visualizer'
                activeMenu="/visualizer"
            />

            <SiteBreadcrumb
                pageTitle="Visualizer"
                pageName="Visualizer"
                breadcrumbsImg={bannerbg}
            />

            <VisualizerMain />

            <BackToTop scroll={isVisible} />
            <Footer />
        </React.Fragment>
    )
}

export default Visualizer;